import {
  MA_WATCHLIST_FAILED_MESSAGE,
  MA_WATCHLIST_PROCESSING_MESSAGE,
} from "../Constants/AppConstants";

export const WATCHLIST_STATUS = Object.freeze({
  DONE: "DONE",
  PROCESSING: "PROCESSING",
  FAILED: "FAILED",
});

const WATCHLIST_STATUS_SET = new Set(Object.values(WATCHLIST_STATUS));

export const normalizeWatchlistStatus = (
  value,
  fallback = WATCHLIST_STATUS.DONE
) => {
  const normalizedValue = `${value ?? ""}`.trim().toUpperCase();
  return WATCHLIST_STATUS_SET.has(normalizedValue)
    ? normalizedValue
    : fallback;
};

export const getWatchlistIdentifier = (watchlist = {}) =>
  watchlist?.watchlistId
  ?? watchlist?.id
  ?? watchlist?.watchlist?.watchlistId
  ?? watchlist?.watchlist?.id
  ?? null;

export const getWatchlistDisplayName = (watchlist = {}) =>
  `${watchlist?.watchlistName ?? watchlist?.watchlist?.watchlistName ?? ""}`.trim();

export const isWatchlistProcessing = (watchlistOrStatus) => {
  const rawStatus =
    watchlistOrStatus && typeof watchlistOrStatus === "object"
      ? watchlistOrStatus?.status
      : watchlistOrStatus;

  return normalizeWatchlistStatus(rawStatus, "") === WATCHLIST_STATUS.PROCESSING;
};

export const isWatchlistFailed = (watchlistOrStatus) => {
  const rawStatus =
    watchlistOrStatus && typeof watchlistOrStatus === "object"
      ? watchlistOrStatus?.status
      : watchlistOrStatus;

  return normalizeWatchlistStatus(rawStatus, "") === WATCHLIST_STATUS.FAILED;
};

export const isBackendDynamicWatchlist = (watchlist = {}) =>
  `${watchlist?.watchlistType ?? ""}`.trim().toLowerCase() === "dynamic";

export const canRetryFailedDynamicWatchlist = (watchlist = {}) =>
  isBackendDynamicWatchlist(watchlist) && isWatchlistFailed(watchlist);

export const getWatchlistFailureMessage = (
  message,
  fallbackMessage = MA_WATCHLIST_FAILED_MESSAGE
) => {
  const trimmedMessage = `${message ?? ""}`.trim();
  return trimmedMessage || fallbackMessage;
};

export const getWatchlistProcessingMessage = (
  _watchlistName = "This watchlist"
) =>
  MA_WATCHLIST_PROCESSING_MESSAGE;

export const getWatchlistMutationProcessingMessage = (
  _watchlistName = "This watchlist"
) =>
  MA_WATCHLIST_PROCESSING_MESSAGE;

export const getWatchlistInventoryProcessingMessage = (
  _watchlistName = "This watchlist"
) =>
  MA_WATCHLIST_PROCESSING_MESSAGE;

export const getWatchlistRetryMessage = (
  _watchlistName = "This watchlist"
) =>
  MA_WATCHLIST_FAILED_MESSAGE;

export const getWatchlistInventoryFailedMessage = (
  _watchlistName = "This watchlist"
) =>
  MA_WATCHLIST_FAILED_MESSAGE;

export const getWatchlistStatusIndicatorTone = (watchlistOrStatus) => {
  if (isWatchlistProcessing(watchlistOrStatus)) {
    return "processing";
  }

  if (isWatchlistFailed(watchlistOrStatus)) {
    return "failed";
  }

  return "default";
};

export const getWatchlistStatusUpdatePayload = (payload = {}) => {
  const source =
    payload?.watchlist && typeof payload.watchlist === "object"
      ? payload.watchlist
      : payload;
  const watchlistId = getWatchlistIdentifier(source);
  const status = normalizeWatchlistStatus(
    source?.status ?? payload?.status,
    ""
  );

  if (watchlistId === null || watchlistId === undefined || status === "") {
    return null;
  }

  return {
    watchlistId,
    watchlistName:
      `${source?.watchlistName ?? payload?.watchlistName ?? ""}`.trim(),
    characteristics: source?.characteristics ?? payload?.characteristics ?? null,
    status,
  };
};
